import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/plm_document'

/** 获取根节点 */
// export const plmRootNodes = () => {
//     return axios.get(`${rootApi}/getDirNodes`)
// }

/** 获取子目录 */
// export const getPlmChildrenNodes = (parentId) => {
//     return axios.get(`${rootApi}/getChildNodes/${parentId}`)
// }

/** 获取所有目录节点 */
export const getPlmAllDirNodes = () => {
    return axios.get(`${rootApi}/getAllDirNodes`)
}

/** 分页查询文档 */
export const searchPlmDocPage = (params) => {
    return axios.get(`${rootApi}/searchList`, { params })
}

/** 获取PLM文件下载路径 */
export const downLoadPlmUrlById = (id) => {
    return axios.get(`${rootApi}/downLoadPlmUrlById?id=${id}`)
}

/** 获取单个文档详细属性 */
// export const getPlmDoc = (docId) => {
// }
